export default __webpack_public_path__ + "static/media/brainy.850871cd.png";